<template>
  <Card class="integration-webtop-basic" tag="form" @submit.prevent="submit">
    <template #header>
      <slot name="header" />
    </template>
    <template #default>
      <SelectComponent
        v-model="value['step']"
        label="Velg byggetrinn"
        sublabel=""
        empty-label="Velg..."
        :items="value.steps"
      />
    </template>
    <template #footer>
      <Alert v-if="error" theme="error" class="integration-webtop-basic__error">{{ error }}</Alert>
      <ButtonComponent
        :label="error ? 'Prøv igjen' : 'Neste'"
        theme="primary"
        :promise="promise"
        :disabled="!validator.passes"
        :icon="['fal', 'arrow-to-right']"
      />
    </template>
  </Card>
</template>

<script>
import Validator from '@/mixins/validator-v2'
import Card from '@kvass/card'
import { InputComponent } from 'vue-elder-input'
import { ButtonComponent } from 'vue-elder-button'
import { AlertComponent as Alert } from 'vue-elder-alert'
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'
import { request } from '@/api/request'

const ValidatorSettings = {
  labels: {
    step: 'Byggetrinn',
  },
  rules: {
    step: 'required',
  },
}

export default {
  mixins: [
    Validator({
      data: 'value',
      labels: 'labels',
      rules: 'rules',
    }),
  ],
  props: {
    value: Object,
  },
  data() {
    return {
      promise: null,
      error: null,

      labels: ValidatorSettings.labels,
      rules: ValidatorSettings.rules,
    }
  },
  methods: {
    submit() {
      if (!this.validator.passes) return

      this.error = null

      this.promise = request(`https://${this.value.account}/api/integration/${this.value.id}/callbacks/init`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.value.token}`,
        },
        mode: 'cors',
        body: JSON.stringify({ ...this.$route.query, CaseId: this.value.step }),
      })
        .then(() => this.$emit('navigate', 'units'))
        .catch(err => {
          this.error = err
          throw err
        })
    },
  },
  components: {
    InputComponent,
    ButtonComponent,
    Card,
    Alert,
    SelectComponent,
  },
}
</script>

<style lang="scss">
.integration-webtop-basic {
  max-width: 600px;

  .kvass-card__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__error {
    white-space: pre-line;
  }
}
</style>
